import { render, staticRenderFns } from "./ServiceLogTable.vue?vue&type=template&id=195cc5f1&xmlns%3Av-data-table=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ServiceLogTable.vue?vue&type=script&lang=js&"
export * from "./ServiceLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
